import { createClient } from '@supabase/supabase-js';

// Environment variables for Cloudflare Pages
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://baoiqaornlzutjnagmgz.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJhb2lxYW9ybmx6dXRqbmFnbWd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgxMTYxMzMsImV4cCI6MjA4MzY5MjEzM30.yxcEMkzRTuY4GO09SF8AxqS2-7VURszS2K0sY9Jdv0s';

export const supabase = createClient(supabaseUrl, supabaseKey);
